import type { Effects } from '@/content/schema';
import { clamp, type DayState } from '@/core/state';
import { tr } from '@/i18n';

/** 所有數值變動的唯一入口。trust 以「級」計，一級 = 5 點。 */
export function applyEffects(day: DayState, e: Effects | undefined): string[] {
  if (!e) return [];
  const f = day.factory, p = day.player, notes: string[] = [];
  const add = (label: string, v: number | undefined, set: (n: number) => void, get: () => number, k = 1) => {
    if (!v) return; set(clamp(get() + v * k)); notes.push(`${label} ${v > 0 ? '+' : ''}${v * k}`);
  };
  add(tr("食安"), e.foodSafety, n => (f.foodSafety = n), () => f.foodSafety);
  add(tr("紀錄完整度"), e.records, n => (f.records = n), () => f.records);
  add(tr("信任"), e.trust, n => (f.trust = n), () => f.trust, 5);
  add(tr("稽核分數"), e.audit, n => (f.audit = n), () => f.audit);
  add(tr("疲勞"), e.fatigue, n => (p.fatigue = n), () => p.fatigue);
  add(tr("壓力"), e.stress, n => (p.stress = n), () => p.stress);
  if (e.reworkMinutes) { f.reworkMinutes += e.reworkMinutes; notes.push(tr("重工 {0} 分鐘", e.reworkMinutes)); }
  return notes;
}

export function tickPlayer(day: DayState, minutes: number, cfg: { fatiguePerHour: number; hydrationLossPerHour: number }) {
  const p = day.player, h = minutes / 60;
  p.hydration = clamp(p.hydration - cfg.hydrationLossPerHour * h);
  const thirsty = p.hydration < 30 ? 1.6 : 1;
  p.fatigue = clamp(p.fatigue + cfg.fatiguePerHour * h * thirsty);
  if (p.fatigue > 70) p.focus = clamp(p.focus - 4 * h);
}
